<script>
import PInput from "../components/p-input";
import PCard from "../components/p-card";
import login from "../services/auth";
import { getAll as getAllTips } from "../services/tips";
import { validate } from "../utils";
import notificationService from "../plugins/notify";
import getConstants from "../services/getConstants";

const TIPS_TO_SHOW = 2;

const isTestExpired = (message) => message == 'TEST_EXPIRED';

export default {
    name: "Login",
    components: {
        PInput,
        PCard,
    },
    data() {
        return {
            form: {},
            errors: {},
            success: false,
            submitDisabled: false,
            tips: [],
            tipsToShow: []
        };
    },
    methods: {
        async submit(e) {
            this.submitDisabled = true;
            this.errors = validate(e);
            if (!!Object.keys(this.errors).length) {
                this.submitDisabled = false;
                return
            }
            
            try {
                const data = await login(this.form);
                this.success = true;
                this.reset(e);
                setTimeout(function(){
                    window.location.assign('/index.php');
                }, 200);
            } catch (error) {
                this.reset(e);
                if(isTestExpired(error.data.message)) {
                    return window.location.assign('/assinar.html');
                }
                new notificationService()
                    .type('error')
                    .message(getConstants(error.data.message))
                    .title('ERRO!')
                    .notify();
                
                this.success = false;
            }
        },
        reset(form) {
            form.target.reset();
            // this.form = {};
            this.errors = {};
            this.submitDisabled = false;
        },
        notify(type, message, title)  {
            new notificationService()
                .type(type)
                .message(message)
                .title(title)
                .notify()
        },
        getTipsToShow() { 
            const selectedTips =[]
            while (selectedTips.length < TIPS_TO_SHOW) {
                const n = Math.floor(Math.random() * this.tips.length);
                const tip = this.tips[n];
                if( !!tip && !selectedTips.some(t => t.id == tip.id))
                selectedTips.push(tip);
            }
            return selectedTips;
        }
    },
    created: async function() {
        try {
            const response = await getAllTips(this.form);
            this.tips = await response.data.message;
            this.tipsToShow = this.getTipsToShow();
        } catch (error) {}
    }
};
</script>
<template>
<section class="main">
    <div class="form-block h-100">
        <p-card>
            <div class="img-logo">
		        <img src="includes/imgs/logo_fundo_branco.png"/>
	        </div>
            <!-- <h2>Seja Bem vindo!</h2> -->
            <form action="" @submit.prevent="submit" class="" novalidate>
                <div class="fields">
            <hr class="separator bg-primary"/>
                    <div class="">
                        <p-input required="true" minlength="3" name="user" label="Usuário" type="text" :error="errors['user']" v-model="form.login"></p-input>
                    </div>

                    <div class="">
                        <p-input required="true" minlength="3" label="Senha" name="password" type="password" :error="errors['password']" v-model="form.password"></p-input>
                    </div>
                </div>
                <div class="footer d-flex justify-content-center align-items-center">
                    <button type="submit" :disabled="submitDisabled" class="btn btn-primary p-2 w-100" name="button" title="Cadastrar"><span class="text">Entrar</span></button>
                </div>
            </form>
        </p-card>
    </div>
    <div class="sidebar h-100">
        <div class="sidebar-content">
            <!-- <div class="side-title">
                <h3>Mais agilidade no seu escritório</h3>
                <p>Com o sistema de cálculos Previd o seu escritório ganha tempo e não precisa se preocupar com todas as regras de cálculos previdenciários. </p>
            </div> -->

            <div class="side-item d-flex" v-for="(tip, index) in tipsToShow" :key="index">
                <!-- <div class="icon"><i class="fa fa-rocket"></i></div> -->
                <p class="text">{{ tip.texto }}</p>
            </div>
        </div>
    </div>
</section>
</template>
<style lang="scss">

.p-input > .inner {
    height: 55px;
}
.p-card {
    box-shadow: none;
    border: none;
}
.img-logo {
    text-align: center;
    margin-bottom: 40px;
    img {
        width: 70%;
    }
}
.main {
    display: flex;
    position: relative;
    height: 100vh;
    background-color: #47525d;
}
.form-block {
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    background-image:url("/includes/imgs/fundo_login.jpg");
    background-color: #fff;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    
    @media screen and (min-width: 60em){
        width: 70%;
        background-image: none;
    }
}
.sidebar {
    position: relative;
    width: 30%;
    display: none;
    background-color: red;
    background-image:url("/includes/imgs/fundo_login.jpg");
    background-color: #fff;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;

    .sidebar-content {
        padding: 2rem 2rem;
        height: 100%;
        overflow: scroll;
        @media screen and (min-width: 1220px){
            padding: 3rem 2.8rem;
        }
    }
    
    @media screen and (min-width: 60em){
        display: block;

        .side-title {
            position: relative;
            z-index: 2;
            margin-bottom: 15px;
            @media screen and (min-width: 1220px){
                margin-bottom: 30px;
            }
        }
        .side-item {
            position: relative;
            z-index: 2;
            padding: 20px 0;
            .text {
                text-shadow: 2px 2px #000000;
                font-size: 14px;
                width: 90%;
                @media screen and (min-width: 1220px){
                    font-size: 17px;
                }
            }
            .icon {
                display: flex;
                align-items: center;
                width: 20%;
                i {
                    font-size: 30px;
                    @media screen and (min-width: 1220px){
                        font-size: 40px;
                    }
                }
            }
        }
    }
    h3 {
        font-family: 'Montserrat', sans-serif;
        font-weight: 400;
        margin-bottom: 10px;
    }
    p {
        font-family: 'Montserrat', sans-serif;
        font-weight: 200;
        font-size: 15px;
    }

    &::before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;;
        z-index: 1;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.54);
    }
}
.p-card {
    padding: 30px 30px;
    width: 90%;
    max-width: 450px;;
    margin: 0 auto;

    h2, p {
        text-align: center;
    }
}
.separator {
    width: 80px;
    height: 5px;
    margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/js/pages/login.vue